module.exports = __webpack_public_path__ + "static/media/moschino-512.ee81d0b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/moschino-512.png
// module id = 775
// module chunks = 0